import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I'm <span className="purple">Kartikeya Pandey</span> from
            <span className="purple"> Pune, Maharashtra, India.</span>
            <br />
            I am an AI Engineer focusing on transformer models, NLP, and
            building scalable backends for ML products.
            <br />
            I am currently pursuing an M.Sc. in Data Science at MIT-WPU Pune
            (Aug 2024 - Present) and completed my B.Sc. in Data Science from
            Bhagwan Mahavir College (2021-2024).
            <br />
            <br />When I'm not coding, I enjoy mentoring, public speaking, and
            learning about efficient model architectures.
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Mentoring and Team Leadership
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing about ML and NLP
            </li>
            <li className="about-activity">
              <ImPointRight /> Building end-to-end ML systems
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Build simple, reliable systems that scale with data and users."
          </p>
          <footer className="blockquote-footer">Kartikeya Pandey</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
